<div class="drawer-container">
    <div
        [@iccDrawerAnimation]="drawerAnimationState"
        class="drawer"
        #drawer
    >
        <icc-transport-filters
            [filters]="filters"
            (filtersEmitter)="setFilters($event)"
            [hasContractorFilter]="hasAccessTo.manageTransport"
        ></icc-transport-filters>

    </div>
    <div class="container">
        <div class="actions">
            <div class="actions-left">
                <button
                    iccButton
                    appearance="secondary"
                    (click)="changeDrawerAnimationState()"
                    *ngIf="mobileView"
                    #drawerButton
                >
                    <icc-icon name="search"></icc-icon>
                    {{ 'INTERFACE|Filtruj' | translate }}
                </button>
                <div *ngIf="hasAccessTo.createTransport">
                    <button iccButton appearance="secondary" (click)="createTransport()" id="new-transport-button">{{ 'TRANSPORT|Zgłoś transport' | translate }}</button>
                </div>
            </div>
            <div class="actions-right">
                <button class="action-button-refresh" iccIconButton appearance="flat-base" (click)="updateList(true)" [title]="'INTERFACE|Odśwież' | translate">
                    <icc-icon name="replay"></icc-icon>
                </button>
            </div>
        </div>

        <div class="table-container">
            <table class="documents-table">
                <thead>
                    <tr>
                        <th><span translate>TRANSPORT|Zgłoszenie</span></th>
                        <th  *ngIf="hasAccessTo.manageTransport"><span translate>TRANSPORT|Kontrahent</span></th>
                        <th><span translate>TRANSPORT|Status</span></th>
                        <th><span translate>TRANSPORT|Data odbioru</span></th>
                        <th translate *ngIf="!mobileView">INTERFACE|Opcje</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let document of allTransports  | paginate: { itemsPerPage: documentsInPage, currentPage: page, totalItems: totalItems };trackBy:trackByUuid">
                        <tr>
                            <td class="documents-table__name" (click)="open(document)">
                                <span>{{ document?.documentNumber?.join ? document?.documentNumber?.join('') : '' }}</span><br>
                                {{ document?.created | date : 'medium' }}
                            </td>
                            <td class="documents-table__client" (click)="open(document)" *ngIf="hasAccessTo.manageTransport">
                                <ng-container *ngIf="document.contractorCompanyName" >
                                    {{ document.contractorCompanyName }}<br>
                                </ng-container>
                                <ng-container *ngIf="document.contractorName" >
                                    {{ document.contractorName }}<br>
                                </ng-container>
                            </td>
                            <td class="documents-table__status" (click)="open(document)">
                                <icc-transport-status [status]="document.status"></icc-transport-status>
                            </td>
                            <td class="documents-table__date" (click)="open(document)" >
                                {{ document?.pickupDate | date : 'shortDate' }}
                            </td>
                            <td *ngIf="!mobileView">
                                <div class="documents-table__options">
                                    <button iccButton appearance="secondary"  (click)="open(document)">
                                        {{ 'INTERFACE|Otwórz' | translate }} <icc-icon name="navigate_next"></icc-icon>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
        <pagination-controls
            (pageChange)="onChangePage($event)"
            [previousLabel]="'INTERFACE|Poprzednia' | translate"
            [nextLabel]="'INTERFACE|Następna' | translate"
            maxSize="6"
        ></pagination-controls>
    </div>
</div>